/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateProjectSchedulingShareInput = {|
  filterApplied?: ?string,
  eyeApplied?: ?string,
  zoomLevel?: ?number,
  companyProjectId?: ?string,
  companyProjectGroupId?: ?string,
  initialPosition?: ?number,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createProjectSchedulingShareMutationVariables = {|
  input: CreateProjectSchedulingShareInput
|};
export type createProjectSchedulingShareMutationResponse = {|
  +createProjectSchedulingShare: ?{|
    +projectSchedulingShare: ?{|
      +url: string
    |}
  |}
|};
export type createProjectSchedulingShareMutation = {|
  variables: createProjectSchedulingShareMutationVariables,
  response: createProjectSchedulingShareMutationResponse,
|};
*/


/*
mutation createProjectSchedulingShareMutation(
  $input: CreateProjectSchedulingShareInput!
) {
  createProjectSchedulingShare(input: $input) {
    projectSchedulingShare {
      url
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectSchedulingShareInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectSchedulingShareMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectSchedulingSharePayload",
        "kind": "LinkedField",
        "name": "createProjectSchedulingShare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSchedulingShare",
            "kind": "LinkedField",
            "name": "projectSchedulingShare",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createProjectSchedulingShareMutation",
    "operationKind": "mutation",
    "text": "mutation createProjectSchedulingShareMutation(\n  $input: CreateProjectSchedulingShareInput!\n) {\n  createProjectSchedulingShare(input: $input) {\n    projectSchedulingShare {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '57021a58a52407dbaa879f30b3b5aac5';

module.exports = node;
